<template>
  <v-dialog
      v-model="overlayDialog"
      width="460"
      :retain-focus="false"> <v-card flat tile>
    <v-card-title class="headline">Új játékos</v-card-title>
    <v-card-text>
      Töltse ki az alábbi mezőket új játékos felvételéhez!
      <br><br>
      <v-select v-model="player" class="width-100" return-object :items="players" item-text="name" label="Játékos"></v-select>
      <vue-numeric-input
          v-model="jersey"
          :min="1"
          :max="99"
          :step="1"
          :align="'center'"
          :class="$vuetify.theme.dark ? 'numeric-theme-dark': 'numeric-theme-light'">
      </vue-numeric-input>
      <v-label>Mez</v-label>
      <v-switch v-model="goalkeeper" class="width-100" label="Kapus"></v-switch>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn depressed tile @click="closeDialog">Mégsem</v-btn>
      <v-btn depressed tile color="green" @click="addPlayer" :disabled="gamefinished||disabledSave">Hozzáadás</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
var debug = require('debug')('MKSZ:PlayerPicker');

import VueNumericInput from 'vue-numeric-input'
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';

export default {
  name: 'PlayerPicker',
  props: [
    'overlay',
    'players',
    'team',
    'takenJerseys',
    'gamefinished',
    'screen'
  ],
  components: {
    VueNumericInput,
  },
  data: () => ({
    player: null,
    goalkeeper: false,
    jersey: 0,
  }),
  computed: {
    overlayDialog: {
      get() {
        return this.overlay;
      },
      set(value) {
        if(!value) {
          eventBus.$emit(CONSTANTS.ACTIONS.HIDEPICKER);
        }
      }
    },
    disabledSave: function () {
      if(this.jersey === 0 || this.takenJerseys.includes(this.jersey)) {
        return true;
      }

      return !this.player;
    }
  },

  methods: {
    addPlayer() {
      debug(this);
      let ret = {};

      if (!this.player) {
        debug("this.player shouldnt be empty");
        eventBus.$emit(CONSTANTS.ACTIONS.HIDEPICKER);
        return;
      }

      if(this.jersey === 0 || this.takenJerseys.includes(this.jersey)) {
        return false;
      }

      let playerTeam = this.team === 'A' ? 'teamA' : 'teamB';

      ret.team = this.team;
      ret.player = {...this.player};
      ret.player.jersey = this.jersey;
      ret.player.team = playerTeam;
      ret.player.official = false;

      // A teremkézilabdában 3 kiállítása lehet a játékosnak
      // Ezek 2 perc után lejárnak
      ret.player.penalties = [];
      ret.player.maxPenalties = 3;

      // Strandkézilabdában nincsenek kiállítások
      // Viszont sárga lapból kettőt kaphat és ezek nem járnak le
      // Ha elérte a kettőt, akkor a kiállításokhoz hasonlóan piros lapot kap
      ret.player.strandYellows = [];
      ret.player.maxKiallitas = 2;

      // A lapok
      ret.player.cards = {
        yellow: {
          value: false,
          given: undefined,
        },
        red: {
          value: false,
          given: undefined,
        },
        blue: {
          value: false,
          given: undefined,
        },
      };
      ret.player.disabled = require('@/DefaultBlockList')();
      ret.player.goalkeeper = this.goalkeeper;
      ret.player.playerEntryScreen = this.screen;

      this.player = null;
      this.goalkeeper = false;

      window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.SYNC, {type: 'playerPicked', content: ret});
      eventBus.$emit(CONSTANTS.ACTIONS.HIDEPICKER);
      eventBus.$emit(CONSTANTS.EVENTS.TEAMUPDATE, ret);
    },
    closeDialog() {
      this.player = null;
      eventBus.$emit(CONSTANTS.ACTIONS.HIDEPICKER);
    }
  },
  watch: {
    jersey: function(newValue, oldValue) {
      if(this.takenJerseys.includes(newValue)) {
        if(newValue > oldValue) {
          this.jersey = this.jersey + 1;
        }
        else if(newValue < oldValue) {
          this.jersey = this.jersey - 1;
        }
      }
    }
  }
}
</script>

<style>
.v-input__control {
  min-height: 0 !important;
}

.vue-numeric-input {
  margin-right: 6px;
}

.vue-numeric-input.numeric-theme-dark > button > i.btn-icon:before {
  background-color: #ffffff !important;
}

.vue-numeric-input.numeric-theme-dark > button > i.btn-icon:after {
  background-color: #ffffff !important;
}

.vue-numeric-input.numeric-theme-light > button > i.btn-icon:before {
  background-color: #000000 !important;
}

.vue-numeric-input.numeric-theme-light > button > i.btn-icon:after {
  background-color: #000000 !important;
}
</style>
